//@flow

import React, { Component } from 'react'
import Nav from '../nav'
import Footer from '../footer'
import Button from '../../front/components/shared/sn-button'
import i18n from '../../locales/i18n'

type Props = {
    +onlyBody: boolean,
}

export default class NotFound extends Component<Props> {

    renderBody = () => (
        <div className="d-flex flex-column align-items-center justify-content-center flex-1 text-center px-1 py-5">
            <div>
                <span>{i18n.t('notFoundScreen.title')}</span>
                <br/>
                <br/>
                <span className="white-space-pre-wrap">{i18n.t('notFoundScreen.text')}</span>
                <br/>
                <Button className="btn btn-lg btn-color-brand mt-5 btn-404" href="/" forceLink>
                    {i18n.t('notFoundScreen.buttonText')}
                </Button>
                <br/>
                <div className="font-weight-bold">{i18n.t('notFoundScreen.name')}</div>
            </div>
        </div>
    )

    render() {
        const { onlyBody } = this.props

        if (onlyBody) {
            return this.renderBody()
        }

        return (
            <>
                <Nav/>

                {this.renderBody()}

                <Footer/>
            </>
        )
    }
}
